import React from "react";

export default function WeekMiniCalendar({
  days = [],
  onSelect,
  selectedDate,
}) {
  return (
    <div className="panel">
      <div style={{ fontWeight: 600, marginBottom: 8 }}>This Week</div>
      <div className="modal-grid" style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
        {days.map((day) => (
          <button
            key={day.date}
            className="btn-secondary"
            onClick={() => onSelect(day)}
            aria-pressed={day.date === selectedDate}
            style={{
              padding: 8,
              border:
                day.date === selectedDate
                  ? "2px solid #111827"
                  : "1px solid #e5e7eb",
              backgroundColor: day.date === selectedDate ? "#f9fafb" : undefined,
            }}
          >
            <div style={{ fontSize: 12 }}>{day.label}</div>
            <div style={{ fontWeight: 600 }}>{day.day}</div>
            {day.dots > 0 && <div style={{ marginTop: 4 }}>•</div>}
          </button>
        ))}
      </div>
    </div>
  );
}
